import {AuwBaseComponent} from "EXT/auw_config/Resources/Private/Js/AuwBaseComponent";

export class AuwSlider extends AuwBaseComponent{

    constructor($el){
        super($el);

        this.config = {
            adaptiveHeight:true,
            dots: false,
            arrows:false,
            autoplay: false,
            autoplaySpeed:3000,
            infinite:true,
            dotsClass:  "slider__dots",
            nextArrow: '<span class="slider__arrow slider__arrow--next far fa-angle-right"></span>',
            prevArrow: '<span class="slider__arrow slider__arrow--prev far fa-angle-left"></span>',
            pauseOnHover: true,
            pauseOnDotsHover: true,
            mobileFirst: true,
            cssEase: "cubic-bezier(.4,0,.2,1)",
            inited: false
        }

    }

    __PageReady(){
        //init erst wenn das erste image geladen wurde // cross loading problem zwischen
        //slick und lazysizes
        if(this.$el.find("img").length && !this.$el.find("img").first().prop("complete")) {
            this.$el.find("img").first().on("load", this.initSlick.bind(this));
        }else{
            this.initSlick();
        }
        //possibly hidden in tab/accordion
        if(!this.$el.is(":visible") && this.$el.parents('.auw_accortabs').length){
            this.$el.parents('.auw_accortabs').on('shown.bs.collapse shown.bs.tab', this.reDoLayouting.bind(this));
        }
    }

    reDoLayouting(){
        this.$el.slick('setPosition');
    }

    initSlick(e){
        if(!this.config.inited) {
            this.config.inited = true;
            this.$el.slick(this.config);
        }
    }
}